module.exports = __webpack_public_path__ + "img/first-0.9d3821db.webp";